.wb_editorContainer {
  display: block;
}

.wb_editor {
  display: flex;
  flex-direction: column;
  width: min-content;
  overflow: hidden;
  white-space: pre-wrap;
  overflow-wrap: break-word;

  /* Default font */
  font-family: sans-serif;
  font-size: 14px;
  line-height: 1.4;

  --aha-editor--user-line-height: 1.4;
}
.wb_editor .aha-editor-v2__body {
  --aha-editor-v2-content-padding: 0;
  color: var(--aha-gray-900);
}
.wb_editor .aha-editor-v2__body * {
  color: inherit;
}
.wb_editor.autoGrow,
.wb_editor.autoGrow .aha-editor-v2__body {
  --aha-editor-v2--content-padding: 0;
  white-space: pre !important;
}
.wb_editor.autoGrow pre,
.wb_editor.autoGrow .aha-editor-v2__body pre {
  overflow-wrap: normal;
  word-break: normal;
  white-space: pre;
}

.wb_editor.editing {
  overflow: visible;
}

.wb_editor .content {
  width: 100%;

  /* Force default color to ignore theming, since the editor will look bad with the dark mode primary text color */
  color: var(--aha-gray-900);
}

.wb_editor .aha-editor-context-toolbar-btn {
  position: absolute;
  right: -5px;
  top: 3px;
  z-index: 9999;
  height: 16px;
}

.wb_editor .aha-editor-context-toolbar-btn:hover .aha-editor-toolbar-btn {
  background-color: var(--theme-editor-button-hovered) !important;
  color: var(--aha-gray-900) !important;
  cursor: pointer;
}

.wb_editor .aha-editor-context-toolbar-btn button {
  border: none;
  border-radius: 4px;
  padding: 0;
  background-color: var(--theme-tertiary-background);
}

.wb_editor .aha-editor-context-toolbar-btn i {
  margin-right: 5px;
}

/*
 * Text styles.
 */
.wb_editor p,
.wb_editor pre {
  margin: 0 !important;
}

.wb_editor {
  ul {
    list-style-type: disc;
    > li > ul {
      list-style-type: circle;
      > li > ul {
        list-style-type: square;
        > li > ul {
          list-style-type: disc;
        }
      }
    }
  }

  ol {
    > li > ol {
      list-style-type: lower-alpha;
      > li > ol {
        list-style-type: lower-roman;
        > li > ol {
          list-style-type: decimal;
        }
      }
    }
  }

  ul,
  ol {
    margin: 0 0 0 calc(var(--default-type-margin) * 2) !important;
    padding: 0;

    p {
      text-align: left !important;
    }

    ul,
    ol {
      margin-bottom: 0;
    }
  }
  li {
    margin-left: -0.1rem;
    text-indent: 0.1rem;
    line-height: 1.4; /* must be same as <p> line-height. */
  }
}

.wb_editor .align-left {
  text-align: left;
}

.wb_editor .align-center {
  text-align: center;
}

.wb_editor .align-right {
  text-align: right;
}

.wb_editor .align-justify {
  text-align: justify;
}

.wb_editor .inline-highlight {
  background-color: var(--aha-yellow-400);
}

.wb_editor a {
  word-wrap: break-word;
}

.wb_editor code {
  font-size: inherit;
  font-family: monospace;
}

.wb_editor ul.checklist {
  list-style-type: none;
}

.wb_editor li.checklist-item--checked,
.wb_editor li.checklist-item--unchecked {
  list-style-type: none;
}

.wb_editor li.checkbox {
  padding-left: 0;
  min-height: auto;
}

.wb_editor li.checkbox input[type='checkbox'] {
  margin: 3px 0 0 -18px;
  position: absolute;
  margin-top: 0;
  margin-left: -15px;
}

.wb_editor li .checklist-item__indicator {
  margin: 0;
  position: absolute;
  margin-left: -1.5ch;
}

.wb_editor code {
  white-space: inherit;
}

.wb_editor table {
  width: 100%;
  word-wrap: break-word;
  table-layout: fixed;
}

.wb_editor td {
  position: relative;
  border: 1px solid var(--theme-primary-border);
  padding: 8px;
  vertical-align: top;
}

.wb_editor blockquote {
  padding: 3px 0 3px 10px;
  border-left: 4px solid var(--theme-light-border);
}

.wb_editor a {
  color: var(--theme-link-text);
  text-decoration: underline;
}

.wb_editor code {
  padding: 2px 4px;
  color: #d14;
  background-color: #f7f7f9;
  border: 1px solid #e1e1e8;
  border-radius: 3px;
}

.wb_editor pre {
  padding: 2px 4px;
  margin: 0;
  display: block;
  background-color: #f7f7f9;
  border: 1px solid #e1e1e8;
  border-radius: 3px;
  word-break: break-all;
  white-space: break-spaces;
  font-size: inherit;
  line-height: inherit;
}
.wb_editor pre code {
  padding: 0;
  color: inherit;
  background-color: transparent;
  border: 0;
}

/* prism.js styles */
.wb_editor .token.comment,
.wb_editor .token.prolog,
.wb_editor .token.doctype,
.wb_editor .token.cdata {
  color: slategray;
}

.wb_editor .token.punctuation {
  color: #999;
}

.wb_editor .token.namespace {
  opacity: 0.7;
}

.wb_editor .token.property,
.wb_editor .token.tag,
.wb_editor token.boolean,
.wb_editor .token.number,
.wb_editor .token.constant,
.wb_editor .token.symbol,
.wb_editor .token.deleted {
  color: #905;
}

.wb_editor .token.selector,
.wb_editor .token.attr-name,
.wb_editor .token.string,
.wb_editor .token.char,
.wb_editor .token.builtin,
.wb_editor .token.inserted {
  color: var(--theme-green-text);
}

.wb_editor .token.operator,
.wb_editor .token.entity,
.wb_editor .token.url,
.wb_editor .language-css .token.string,
.wb_editor .style .token.string {
  color: var(--aha-orange-800);
  /* This background color was intended by the author of this theme. */
  background: hsla(0, 0%, 100%, 0.5);
}

.wb_editor .token.atrule,
.wb_editor .token.attr-value,
.wb_editor .token.keyword {
  color: var(--aha-blue-500);
}

.wb_editor .token.function,
.wb_editor .token.class-name {
  color: var(--aha-red-600);
}

.wb_editor .token.regex,
.wb_editor .token.important,
.wb_editor .token.variable {
  color: var(--aha-orange-600);
}

.wb_editor .token.important,
.wb_editor .token.bold {
  font-weight: bold;
}
.wb_editor .token.italic {
  font-style: italic;
}

.wb_editor .frameText {
  color: var(--aha-gray-700);
}

.wb_editor h1,
.wb_editor h2,
.wb_editor h3,
.wb_editor h4 {
  font-family: sans-serif !important;
  font-weight: bold;
  border-bottom: none;
  line-height: inherit;
  padding: 0;
  margin: 0;
}

.wb_editor h1 {
  font-size: 1.8em;
}

.wb_editor h2 {
  font-size: 1.7em;
}

.wb_editor h3 {
  font-size: 1.5em;
}

.wb_editor h4 {
  font-size: 1.4em;
}
